import { playTones } from "../../../utils/audioContext";

// Re-exported so the existing callers (ChatContext's gesture listener, the Chat page's
// permission banner) keep importing them from here; the context itself is shared app-wide now.
export { unlockAudioContext, isAudioUnlocked } from "../../../utils/audioContext";

// The chat chime: a quick RISING fourth on a sine wave, bright and chirpy.
//
// Its shape is what tells a chat message apart from a bell notification by ear alone, so it is
// paired deliberately with the notification chime in
// layouts/components/Notifications/notificationSound.js — that one is the same interval
// inverted (falling, on a triangle wave), related enough to sound like one family, opposite
// enough that nobody has to look at the screen to know which arrived.
const CHAT_NOTES = [
    { freq: 880, start: 0, duration: 0.12 },   // A5
    { freq: 1175, start: 0.1, duration: 0.18 }, // D6
];

const playNotificationSound = () => playTones(CHAT_NOTES, { type: 'sine', volume: 0.2 });

export default playNotificationSound;
